/** Remembers, in memory only, which keys were already claimed since the page loaded. */
export type OncePerPageLoad = {
  claim: (key: string) => boolean;
};

export const createOncePerPageLoad = (): OncePerPageLoad => {
  const claimed = new Set<string>();

  return {
    claim: (key) => {
      if (claimed.has(key)) return false;

      claimed.add(key);

      return true;
    },
  };
};

export const resumedThreadReports = createOncePerPageLoad();
